export const borderColorVariants = {
  'border-color': {
    primary: 'border-border-primary',
    'primary-disabled': 'border-border-primary-disabled',
    'primary-inverse': 'border-border-primary-inverse',
    secondary: 'border-border-secondary',
    'secondary-disabled': 'border-border-secondary-disabled',
    'secondary-error': 'border-border-secondary-error',
    'secondary-selected': 'border-border-secondary-selected',
    tertiary: 'border-border-tertiary',
    'tertiary-selected': 'border-border-tertiary-selected',
    'tertiary-error': 'border-border-tertiary-error',
    quarternary: 'border-border-quarternary',
    transparent: 'border-transparent',
    deco: 'border-deco',
    success: 'border-green-700',
    warning: 'border-orange-700',
    info: 'border-info-700',
    danger: 'border-red-700',
  },
  'border-color-sm': {
    primary: 'sm:border-border-primary',
    'primary-disabled': 'sm:border-border-primary-disabled',
    'primary-inverse': 'sm:border-border-primary-inverse',
    secondary: 'sm:border-border-secondary',
    'secondary-disabled': 'sm:border-border-secondary-disabled',
    'secondary-error': 'sm:border-border-secondary-error',
    'secondary-selected': 'sm:border-border-secondary-selected',
    tertiary: 'sm:border-border-tertiary',
    'tertiary-selected': 'sm:border-border-tertiary-selected',
    'tertiary-error': 'sm:border-border-tertiary-error',
    quarternary: 'sm:border-border-quarternary',
    transparent: 'sm:border-transparent',
    deco: 'sm:border-deco',
    success: 'sm:border-green-700',
    warning: 'sm:border-orange-700',
    info: 'sm:border-info-700',
    danger: 'sm:border-red-700',
  },
  'border-color-md': {
    primary: 'md:border-border-primary',
    'primary-disabled': 'md:border-border-primary-disabled',
    'primary-inverse': 'md:border-border-primary-inverse',
    secondary: 'md:border-border-secondary',
    'secondary-disabled': 'md:border-border-secondary-disabled',
    'secondary-error': 'md:border-border-secondary-error',
    'secondary-selected': 'md:border-border-secondary-selected',
    tertiary: 'md:border-border-tertiary',
    'tertiary-selected': 'md:border-border-tertiary-selected',
    'tertiary-error': 'md:border-border-tertiary-error',
    quarternary: 'md:border-border-quarternary',
    transparent: 'md:border-transparent',
    deco: 'md:border-deco',
    success: 'md:border-green-700',
    warning: 'md:border-orange-700',
    info: 'md:border-info-700',
    danger: 'md:border-red-700',
  },
  'border-color-lg': {
    primary: 'lg:border-border-primary',
    'primary-disabled': 'lg:border-border-primary-disabled',
    'primary-inverse': 'lg:border-border-primary-inverse',
    secondary: 'lg:border-border-secondary',
    'secondary-disabled': 'lg:border-border-secondary-disabled',
    'secondary-error': 'lg:border-border-secondary-error',
    'secondary-selected': 'lg:border-border-secondary-selected',
    tertiary: 'lg:border-border-tertiary',
    'tertiary-selected': 'lg:border-border-tertiary-selected',
    'tertiary-error': 'lg:border-border-tertiary-error',
    quarternary: 'lg:border-border-quarternary',
    transparent: 'lg:border-transparent',
    deco: 'lg:border-deco',
    success: 'lg:border-green-700',
    warning: 'lg:border-orange-700',
    info: 'lg:border-info-700',
    danger: 'lg:border-red-700',
  },
  'border-color-xl': {
    primary: 'xl:border-border-primary',
    'primary-disabled': 'xl:border-border-primary-disabled',
    'primary-inverse': 'xl:border-border-primary-inverse',
    secondary: 'xl:border-border-secondary',
    'secondary-disabled': 'xl:border-border-secondary-disabled',
    'secondary-error': 'xl:border-border-secondary-error',
    'secondary-selected': 'xl:border-border-secondary-selected',
    tertiary: 'xl:border-border-tertiary',
    'tertiary-selected': 'xl:border-border-tertiary-selected',
    'tertiary-error': 'xl:border-border-tertiary-error',
    quarternary: 'xl:border-border-quarternary',
    transparent: 'xl:border-transparent',
    deco: 'xl:border-deco',
    success: 'xl:border-green-700',
    warning: 'xl:border-orange-700',
    info: 'xl:border-info-700',
    danger: 'xl:border-red-700',
  },
}
